import { render } from "./comments.vue?vue&type=template&id=bff28248&ts=true"
import script from "./comments.vue?vue&type=script&lang=ts"
export * from "./comments.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__